"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppraisalScreenAction = exports.APPRAISAL_BUSINESS_DAYS = exports.AppraisalOrderStatus = exports.isAppraisalBorrowerPaid = exports.isExteriorDriveByAppraisalProductType = exports.AppraisalRequirementReason = exports.getAppraisalNoticeVariant = exports.AppraisalNoticeVariant = exports.HUMAN_READABLE_NAME_FOR_APPRAISAL_PRODUCT_TYPE = exports.StatedValueAppraisalType = exports.AppraisalSourceType = exports.AppraisalPaymentSource = exports.AppraisalProductType = void 0;
const assertUtils_1 = require("../assertUtils");
const math_1 = require("./slider/math");
// Covers the two Fannie Mae appraisal forms we care about (see
// https://singlefamily.fanniemae.com/learning-center/applications/appraisers-property-underwriting for details),
// plus Broker Price Opinion products
// plus hybrid appraisal for purchase flh
/** @TranslateToPython */
var AppraisalProductType;
(function (AppraisalProductType) {
    AppraisalProductType["UNIFORM_RESIDENTIAL_APPRAISAL_1004"] = "UNIFORM_RESIDENTIAL_APPRAISAL_1004";
    AppraisalProductType["HYBRID_RESIDENTIAL_APPRAISAL_1004"] = "HYBRID_RESIDENTIAL_APPRAISAL_1004";
    AppraisalProductType["EXTERIOR_ONLY_RESIDENTIAL_REPORT_2055"] = "EXTERIOR_ONLY_RESIDENTIAL_REPORT_2055";
    AppraisalProductType["BROKER_PRICE_OPINION_EXTERIOR"] = "BROKER_PRICE_OPINION_EXTERIOR";
    AppraisalProductType["BROKER_PRICE_OPINION_INTERIOR"] = "BROKER_PRICE_OPINION_INTERIOR";
    AppraisalProductType["EVALUATION_EXTERIOR"] = "EVALUATION_EXTERIOR";
})(AppraisalProductType || (exports.AppraisalProductType = AppraisalProductType = {}));
// BORROWER: the borrower prepaid the appraisal vendor via payment link; AVEN: Aven is invoiced or pays by card.
/** @TranslateToPython */
var AppraisalPaymentSource;
(function (AppraisalPaymentSource) {
    AppraisalPaymentSource["BORROWER"] = "BORROWER";
    AppraisalPaymentSource["AVEN"] = "AVEN";
})(AppraisalPaymentSource || (exports.AppraisalPaymentSource = AppraisalPaymentSource = {}));
/** @TranslateToPython */
var AppraisalSourceType;
(function (AppraisalSourceType) {
    AppraisalSourceType["REGGORA"] = "REGGORA";
    AppraisalSourceType["CLEARCAPITAL"] = "CLEARCAPITAL";
    AppraisalSourceType["MANUAL"] = "MANUAL";
    AppraisalSourceType["ENCORE"] = "ENCORE";
})(AppraisalSourceType || (exports.AppraisalSourceType = AppraisalSourceType = {}));
/**
 * The appraisal the loan officer chooses for an offer priced off a stated home value: an exterior drive-by, whose product
 * depends on the property state, or a full 1004.
 * @TranslateToPython
 */
var StatedValueAppraisalType;
(function (StatedValueAppraisalType) {
    StatedValueAppraisalType["exteriorDriveBy"] = "exteriorDriveBy";
    StatedValueAppraisalType["fullAppraisal"] = "fullAppraisal";
})(StatedValueAppraisalType || (exports.StatedValueAppraisalType = StatedValueAppraisalType = {}));
exports.HUMAN_READABLE_NAME_FOR_APPRAISAL_PRODUCT_TYPE = {
    [AppraisalProductType.UNIFORM_RESIDENTIAL_APPRAISAL_1004]: '1004 Full Appraisal',
    [AppraisalProductType.HYBRID_RESIDENTIAL_APPRAISAL_1004]: '1004 Hybrid Appraisal',
    [AppraisalProductType.EXTERIOR_ONLY_RESIDENTIAL_REPORT_2055]: '2055 Exterior Appraisal',
    [AppraisalProductType.BROKER_PRICE_OPINION_EXTERIOR]: 'BPO Exterior',
    [AppraisalProductType.BROKER_PRICE_OPINION_INTERIOR]: 'BPO Interior',
    [AppraisalProductType.EVALUATION_EXTERIOR]: 'Exterior Evaluation',
};
// The appraisal notice shown at offer time explains one of three experiences: a quick exterior drive-by (the
// stated-value BPO/evaluation path), a full appraisal, or a full appraisal on a megaline, which also needs two years
// of income verification. Frontends switch this variant to their own localized copy.
var AppraisalNoticeVariant;
(function (AppraisalNoticeVariant) {
    AppraisalNoticeVariant["EXTERIOR_DRIVE_BY"] = "EXTERIOR_DRIVE_BY";
    AppraisalNoticeVariant["NON_MEGALINE_1004"] = "NON_MEGALINE_1004";
    AppraisalNoticeVariant["MEGALINE_1004"] = "MEGALINE_1004";
})(AppraisalNoticeVariant || (exports.AppraisalNoticeVariant = AppraisalNoticeVariant = {}));
const getAppraisalNoticeVariant = ({ productType, lineSizeCents, megaLineThreshold, }) => {
    switch (productType) {
        case AppraisalProductType.BROKER_PRICE_OPINION_EXTERIOR:
        case AppraisalProductType.EVALUATION_EXTERIOR:
            return AppraisalNoticeVariant.EXTERIOR_DRIVE_BY;
        case AppraisalProductType.UNIFORM_RESIDENTIAL_APPRAISAL_1004:
        case AppraisalProductType.HYBRID_RESIDENTIAL_APPRAISAL_1004:
        case AppraisalProductType.EXTERIOR_ONLY_RESIDENTIAL_REPORT_2055:
        case AppraisalProductType.BROKER_PRICE_OPINION_INTERIOR:
        case undefined:
            if (megaLineThreshold !== null && lineSizeCents !== undefined && lineSizeCents <= (0, math_1.roundDecimalProduct)(megaLineThreshold, 100)) {
                return AppraisalNoticeVariant.NON_MEGALINE_1004;
            }
            return AppraisalNoticeVariant.MEGALINE_1004;
        default:
            return (0, assertUtils_1.assertNever)(productType, `Unhandled AppraisalProductType ${productType}`);
    }
};
exports.getAppraisalNoticeVariant = getAppraisalNoticeVariant;
/** @TranslateToPython */
var AppraisalRequirementReason;
(function (AppraisalRequirementReason) {
    AppraisalRequirementReason["FIRST_LIEN_PURCHASE"] = "FIRST_LIEN_PURCHASE";
    AppraisalRequirementReason["MEGALINE_WITH_ATTESTED_VALUE"] = "MEGALINE_WITH_ATTESTED_VALUE";
    AppraisalRequirementReason["MEGALINE"] = "MEGALINE";
    AppraisalRequirementReason["AVM_DISPUTE"] = "AVM_DISPUTE";
    AppraisalRequirementReason["AVM_NOT_FOUND"] = "AVM_NOT_FOUND";
})(AppraisalRequirementReason || (exports.AppraisalRequirementReason = AppraisalRequirementReason = {}));
// Until a line size is picked, a partner appraisal may be an exterior drive-by (BPO / evaluation) or a full 1004.
const PARTNER_APPRAISAL_PRODUCT_TYPES = [
    AppraisalProductType.BROKER_PRICE_OPINION_EXTERIOR,
    AppraisalProductType.EVALUATION_EXTERIOR,
    AppraisalProductType.UNIFORM_RESIDENTIAL_APPRAISAL_1004,
];
const isExteriorDriveByAppraisalProductType = (productType) => {
    return productType === AppraisalProductType.BROKER_PRICE_OPINION_EXTERIOR || productType === AppraisalProductType.EVALUATION_EXTERIOR;
};
exports.isExteriorDriveByAppraisalProductType = isExteriorDriveByAppraisalProductType;
// With no product type yet, only claim the borrower pays when every appraisal the partner inquiry could need is
// borrower-paid, since a 1004 can still go to an Aven-invoiced appraisal vendor.
const isAppraisalBorrowerPaid = (borrowerPaidAppraisalProductTypes, productType) => {
    if (productType === undefined) {
        return PARTNER_APPRAISAL_PRODUCT_TYPES.every((partnerProductType) => borrowerPaidAppraisalProductTypes.includes(partnerProductType));
    }
    return borrowerPaidAppraisalProductTypes.includes(productType);
};
exports.isAppraisalBorrowerPaid = isAppraisalBorrowerPaid;
/** @TranslateToPython */
var AppraisalOrderStatus;
(function (AppraisalOrderStatus) {
    // Initial status when order is created. Order has not been submitted yet.
    AppraisalOrderStatus["PENDING"] = "PENDING";
    // Order is submitted and initial payment (if necessary) has been made.
    AppraisalOrderStatus["FINDING_APPRAISER"] = "FINDING_APPRAISER";
    // Appraiser has been found and order is being processed.
    AppraisalOrderStatus["APPRAISER_FOUND"] = "APPRAISER_FOUND";
    // Inspection has been scheduled.
    AppraisalOrderStatus["INSPECTION_SCHEDULED"] = "INSPECTION_SCHEDULED";
    // Inspection has been completed.
    AppraisalOrderStatus["INSPECTION_COMPLETED"] = "INSPECTION_COMPLETED";
    // Report is available and ready to be reviewed by us.
    AppraisalOrderStatus["REPORT_READY_FOR_REVIEW"] = "REPORT_READY_FOR_REVIEW";
    // Report has been accepted by us and order is complete.
    AppraisalOrderStatus["REPORT_ACCEPTED"] = "REPORT_ACCEPTED";
    // Order has been cancelled by us.
    AppraisalOrderStatus["CANCELLED"] = "CANCELLED";
    // Order has been put on hold by us.
    AppraisalOrderStatus["ON_HOLD"] = "ON_HOLD";
    // Order requires further action from us.
    AppraisalOrderStatus["ATTENTION_REQUIRED"] = "ATTENTION_REQUIRED";
})(AppraisalOrderStatus || (exports.AppraisalOrderStatus = AppraisalOrderStatus = {}));
/**
 * Estimated business days for appraisal completion.
 * Used in frontend UI and backend communications.
 * @TranslateToPython
 */
exports.APPRAISAL_BUSINESS_DAYS = 7;
var AppraisalScreenAction;
(function (AppraisalScreenAction) {
    AppraisalScreenAction["showWaitingPage"] = "showWaitingPage";
    AppraisalScreenAction["forwardToNextAction"] = "forwardToNextAction";
})(AppraisalScreenAction || (exports.AppraisalScreenAction = AppraisalScreenAction = {}));
